import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./RulesPassword.module.scss";

const RulesPassword = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.rules_password}>
      <span className={styles.title_rules}>
        {t("password.rules_title")}
      </span>
      <span>{t("password.at_least_8_chars")}</span>
      <span>{t("password.at_least_1_uppercase")}</span>
      <span>{t("password.at_least_1_lowercase")}</span>
      <span>{t("password.at_least_1_number")}</span>
      <span>{t("password.special_character")}</span>
    </div>
  );
};

export default RulesPassword;
